<div class="card">
  <h5 class="card-header">RI Details</h5>
  <div style="display: flex; justify-content: flex-end; align-items: center; gap: 10px; margin: 10px;">
    <input class="datetimepicker" type="text" [(ngModel)]="dateRange" style="padding: 10px;" />
    <button class="btn btn-primary-soft" (click)="load()">
      Refresh
    </button>
  </div>
  <div class="card-body">
    <table class="table table-docs table-hover">
      <thead>
        <tr>
          <th>S.N.</th>
          <th *ngFor="let h of headers">{{h.name}}</th>
        </tr>
      </thead>
      <tbody [ngStyle]="{'display': s3List.length > 0 ? 'table-row-group': ''}">
        <tr *ngFor="let i of s3List; let j = index">
          <td>{{j+1}}</td>
          <td *ngFor="let h of headers">
            <span *ngIf="h.click" class="btn" (click)="callFunction(h.click, i)">
              <span>
                {{i[h.id]}}
              </span>
            </span>
            <span *ngIf="!h.click">
              <span>{{i[h.id]}}</span>
            </span>
          </td>
        </tr>
      </tbody>
      <tbody [ngStyle]="{'display': s3List.length == 0 ? 'table-row-group' : 'none'}">
        <tr>
          <td [attr.colspan]="headers.length + 1">
            <div style="text-align: center;">No Data Found</div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<modal-popup [headers]="riPurshasedHeader" *ngIf="riPurchasedModal" [data]="riPurchasedModal"
  [modalTitle]="'RI Purchased'" [showModal]="riPurchasedModal" (hideModal)="hidePop($event)"></modal-popup>